import React from "react";
import { css } from "@emotion/react";
import consulting from "@src/assets/expert/consulting.png";
import writingFace from "@src/assets/expert/writingFace.png";
import {
    noticeContainerStyle,
    TitleStyle,
    ContentContainerStyle,
    BlueBoxStyle,
    BlueTitleStyle,
    BlackTitleStyle,
    BlackStepStyle,
    DarkGreyContentStyle,
    dividerStyle,
} from "./TakerAgentNotice";

const UserAccompanyNotice = () => {
    return (
        <div css={noticeContainerStyle}>
            <div css={TitleStyle}>
                임장동행 <br />
                <span style={{ fontWeight: "normal", fontSize: "18px" }}>서비스 이렇게 진행돼요!</span>
            </div>
            <div css={ContentContainerStyle}>
                {/* Step1 */}
                <div className="stepBox">
                    <img src={consulting} alt="consulting" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.01</span> 임장동행
                    </p>
                    <div css={BlueBoxStyle}>
                        <p css={BlueBoxDescStyle}>임장동행 자격을 갖춘 경매 전문가와 함께 임장동행을 하실 수 있어요.</p>
                        <p css={CostTextStyle}>✔️ 임장동행 비용 : 22만원</p>
                        <div css={dividerStyle} style={{ margin: "0 0 14px 0" }} />
                        <div css={NumberedListStyle}>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>1</div>
                                <div>
                                    <p css={BlueTitleStyle}>의뢰 요청</p>
                                    <p css={ItemDescStyle}>
                                        매물의 사건번호, 요청사항을 입력하고 전국에 있는 경매대행 전문가에게 즉시 의뢰를 보내요.
                                    </p>
                                </div>
                            </div>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>2</div>
                                <div>
                                    <p css={BlueTitleStyle}>원하는 전문가 선택</p>
                                    <p css={ItemDescStyle}>
                                        전문가들은 해당 의뢰에 실시간으로 지원하고, 의뢰인은 지원한 전문가들의 프로필을 확인하거나
                                        채팅을 하며 자신이 원하는 전문가를 직접 선택해요.
                                    </p>
                                </div>
                            </div>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>3</div>
                                <div>
                                    <p css={BlueTitleStyle}>매칭 완료</p>
                                    <p css={ItemDescStyle}>
                                        지원한 전문가 중 한 명을 선택하고 {"'"}매칭확정하기{"'"}를 눌러 담당 전문가로 지정하면,
                                        매칭이 완료돼요.
                                    </p>
                                </div>
                            </div>
                            <div css={NumberedItemStyle}>
                                <div css={BlueCircleStyle}>4</div>
                                <div>
                                    <p css={BlueTitleStyle}>임장동행</p>
                                    <p css={ItemDescStyle}>
                                        전문가와 함께 현장을 방문하여, 물건 상태를 점검하고 필요한 정보를 제공받아요.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Step2 */}
                <div className="stepBox">
                    <img src={writingFace} alt="writingFace" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>Step.02</span> 후기 작성
                    </p>
                    <p css={DarkGreyContentStyle} style={{ marginTop: "14px", fontSize: "12px" }}>
                        매칭된 전문가에 대한 후기를 작성해요. 제공 받은 매수신청대리 서비스가 어땠는지 좋은 점, 아쉬운 점을
                        작성해주세요.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UserAccompanyNotice;

const BlueBoxDescStyle = css`
    color: #382e51;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.4;
`;

const CostTextStyle = css`
    color: #3c3c3c;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 14px;
    margin-bottom: 6px;
`;

const NumberedListStyle = css`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

const NumberedItemStyle = css`
    display: flex;
    gap: 6px;
    align-items: flex-start;
`;

const BlueCircleStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    min-width: 16px;
    background-color: #2275ee;
    border-radius: 1000px;
    color: white;
    font-size: 11px;
    font-weight: bold;
    margin-top: 2px;
`;

const ItemDescStyle = css`
    color: #8d8d8d;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 8px;
`;
